<template functional>
  <v-chip
    label
    dark
    small
    :class="data.staticClass"
    :color="props.status === 'Active' ? 'green' : 'grey'"
  >
    {{ props.status === 'Pending' ? 'Listing Pending' : props.status }}
  </v-chip>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AvailabilityStatusChip',

  props: {
    status: {
      type: String,
      required: true
    },
  },
});
</script>
